import { Component, OnInit, TemplateRef } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { PlatformLocation } from '@angular/common';

import * as $ from 'jquery';
declare var $: any;



export class Person {
  constructor(
   public name: string,
   public signUp: string,
   
   ) {}
 }


@Component({
  selector: 'app-referrallist',
  templateUrl: './referrallist.component.html',
  styleUrls: ['./referrallist.component.css'],
  // providers: [ToasterService]
})
export class ReferrallistComponent implements OnInit {

  modalRef: BsModalRef;
  redeemSuccess: boolean = true;
  userId:any;

  referral_id:any;
  redeemAmount: any;
  referralistdetails:any;
  finalReferralistDetails:any=[];

  deletereferralistdetails:any;

  error: string;
  username: string;
  email: string;
  mobile: string;

  sendEmail:any;
  name:any;
  issignup:boolean;

  message:"gggggggg";
  key : string;

  time : string;
  oldtime:any;

  referralid1:any;

  mailContent:string;
  dynamicMailContent:string;
  mailSubject:string;

  loading: boolean;

  emailRequestData: {};
  referralData:any={};
  disabled_data:any;

  isdisables : boolean = true;

  user:{};
  toaster:any;
  linkurl:string="https://securenow.app/";

  isreferralbuttom:boolean=false;

  public isVisible: boolean = false;

  public people: any[];
  pamReferral:any;
  isShowReferral:boolean=true;
  constructor(private router: Router, 
    private serviceURLService: serviceURLService, 
    private modalService: BsModalService,
    private platformLocation: PlatformLocation) {

      this.username = localStorage.getItem('name');
      this.email = localStorage.getItem('email');
      this.mobile = localStorage.getItem('mobileNumber');
  
  }

  ngOnInit() {
   // this. getPamReferral();
    this.userId = localStorage.getItem("userID");
    this.getReferra();
      setTimeout (() => {
      this.gettime();

      if(!this.referralistdetails.length && !this.pamReferral.length){
        this.isShowReferral=false;
      }
    }, 1000);
  }

  openModal(template: TemplateRef<any>) {
    this.redeemSuccess = false;
    this.modalRef = this.modalService.show(template, { class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false });
  }
  
  gettime(){


console.log("inside gettime");

  //   for(let  i=0; i<this.referralistdetails.length; i++) {
  //     var x=this.referralistdetails[i]._id
  //     console.log("inside for loop "+x +" position at " +i)
  //     var time1 = new Date();
  //     this.key = "id" + x;
  //     this.time = "time" + x;
  //     var time2 = JSON.parse(localStorage.getItem(this.time));
  //   const time3 = new Date(time2);
  //   if(time2){
  //     console.log("inside time check ");
      
  //     let hours = Math.abs(time1.valueOf() - time3.valueOf()) / 36e5;
  //     if(hours<24){
  //       console.log("inside condition");
  //       (document.getElementById(x) as any).disabled = true;
  //     }
  //     else{
  //       (document.getElementById(x) as any).disabled = false;
  //     }

  //   }
  // }


  for(let  i=0; i<this.referralistdetails.length; i++) {
    var x=this.referralistdetails[i]._id;
    console.log("inside for loop "+x +" position at " +i)
    var currentTime = new Date();
    var dbTime = this.referralistdetails[i].disableEmailTime;
    var disablefield =  this.referralistdetails[i].disable;
    console.log(this.referralistdetails[i].disableEmailTime);
    const dbTimeConvert = new Date(dbTime);
  if(dbTime){
    console.log("inside time check ");
    
    let hours = Math.abs(currentTime.valueOf() - dbTimeConvert.valueOf()) / 36e5;
    console.log("inside condition " + disablefield + x);
    if( disablefield == true){
     
      (document.getElementById(x) as any).disabled = true;
    }

    else if(hours<24){
      console.log("inside condition");
      (document.getElementById(x) as any).disabled = true;
    }

    else{
      (document.getElementById(x) as any).disabled = false;
    }

  }

  else{
    if( disablefield == true){
     
      (document.getElementById(x) as any).disabled = true;
    }

    else{
      (document.getElementById(x) as any).disabled = false;

    }
  }
  
}

  }

  getReferra() {
    this.loading = true;
    this.referralData={
      "loggedInUser":this.userId ,
      "mobile": this.mobile
    }
    this.serviceURLService.referralist(this.referralData).subscribe((success: any) => {
      this.referralistdetails = success.response.refferedUserlist;



      this.referralistdetails.map(singleState=>{

        if(singleState.pamProspectId){
          this.serviceURLService.getReferralStatus(singleState.pamProspectId).subscribe((statusData:any)=>{
          singleState.status=statusData.data;
         // this.finalReferralistDetails.push(JSON.parse(JSON.stringify(singleState)));
      }, error=>{
        singleState.status="NA"
        //this.finalReferralistDetails.push(JSON.parse(JSON.stringify(singleState)));
        console.log( " error for fetching status for "+singleState.pamProspectId)
      })
    }else {
      singleState.status="NA"
        // this.finalReferralistDetails.push(JSON.parse(JSON.stringify(singleState)));
    }
       
      })



//       for(let  i=0; i<this.referralistdetails.length; i++) {
//         if(this.referralistdetails[i].pamProspectId){
//         this.serviceURLService.getReferralStatus(this.referralistdetails[i].pamProspectId).subscribe((statusData:any)=>{
//         this.referralistdetails[i].status=statusData.data;
//         this.finalReferralistDetails.push(JSON.parse(JSON.stringify(this.referralistdetails[i])));
//     }, error=>{
//       this.referralistdetails[i].status="NA"
//       this.finalReferralistDetails.push(JSON.parse(JSON.stringify(this.referralistdetails[i])));
//       console.log( " error for fetching status for "+this.referralistdetails[i].pamProspectId)
//     })
//   }else {
//     this.referralistdetails[i].status="NA"
//     this.finalReferralistDetails.push(JSON.parse(JSON.stringify(this.referralistdetails[i])));
//   }
// }

        
        // this.data.name= this.referralistdetails[i].name;

      //   var x=this.referralistdetails[i]._id
      //   console.log("inside for loop "+x +" position at " +i)
      //   var time1 = new Date();
      //   this.key = "id" + x;
      //   this.time = "time" + x;
      //   var time2 = JSON.parse(localStorage.getItem(this.time));
      // const time3 = new Date(time2);
      // if(time2){
      //   console.log("inside time check ");
      //   (document.getElementById(x) as any).disabled = true;
      //   let hours = Math.abs(time1.valueOf() - time3.valueOf()) / 36e5;
      //   if(hours<4){
      //     console.log("inside condition");
      //     $('#x').prop('disabled', true);
      //   }
      //   else{
      //     (document.getElementById(x) as any).disabled = false;
      //   }

      // }

        // if(this.referralistdetails[i].signUp == "true"){
        //     // this.data.signUp="YES";    
        //     // Person x= this.people.push (new Person (this.referralistdetails[i].name,'YES') )   
        //     var x= new Person (this.referralistdetails[i].name,'YES'); 
        //     this.people.push(x);
        // }

        // if(this.referralistdetails[i].signUp == "false"){
        //   var x= new Person (this.referralistdetails[i].name,'NO'); 
        //   this.people.push(x);

          // this.data.signUp="NO";
          // Person x= this.people.push (new Person (this.referralistdetails[i].name,'NO') ) 
          // new Person (this.referralistdetails[i].name,'NO')           
    
        // this.datalist.push(this.data)
        // console.log(" After conversion== " + this.datalist);

        // console.log(" After conversionlist== " + (new Person (this.referralistdetails[i].name,'YES')).name);
     // }
     

      // console.log(" testinhg== " + this.referralistdetails.refferedUserlist[0].name);
      // this.name = this.convertRedeemAmount(this.referralData.Balance);

      this.loading = false;
    },error => {
      this.loading = false;
    })
  }

  deleteReferrallist1(userid){
    this.referralid1 = userid;
  }

  deleteReferrallist() {
    console.log("delete list before " + this.referralid1)
    this.loading = true;
    this.serviceURLService.deletereferralist(this.referralid1).subscribe((success: any) => {
    this.referral_id = success.response;
    console.log("get_reminder print==" + this.referral_id);
      
    (document.getElementById(this.referralid1) as any).disabled = true;

    this.isdisables = false;


  

      setTimeout (() => {
        this.gettime();
      }, 500);
      // this.gettime();
      this.getReferra();
      this.loading = false;
    },error => {
      this.loading = false;
    })
  }

  reminderLoginUser(referralData) {
   
     this.user={
      bccEmail: this.email,
      bccName: this.username,
     }

     this.mailContent = "<p>Testing mail</p>",
     this.mailSubject ="Testing Mail"


     let data1= {
      "user": [
        {
          // "bccEmail": "deepak.k@neosoftmail.com",
          "bccEmail": this.email,
          "bccName": this.username
        }
      ],
      "mailContent": "<b>"+"Dear " + this.username + "," + "</b> " + "<br>" + "<br>" +"Reminder Mail sent sucessfully to " + referralData.name,
      "mailSubject": "Referral Reminder Mail",
      "referral_id":  referralData._id,
      "attachments": []
    }

    console.log("loginuser " + data1.mailContent);
    this.disabled_data= referralData._id;
    console.log("button id " + this.disabled_data);
    this.loading = true;
    this.serviceURLService.sendEmails(data1).subscribe((success: any) => {
    this.sendEmail = success.response;
    this.isreferralbuttom=true;
    $('#checkReminder').modal('show');
    var x= referralData._id;
  // var time1 = new Date();
  // this.key = "id" + x;
  // this.time = "time" + x;
  //   localStorage.setItem(this.key, x);
  //   localStorage.setItem(this.time , JSON.stringify(time1));
    (document.getElementById(x) as any).disabled = true;
  

      this.loading = false;
    },error => {
      this.loading = false;
    })
  }


  reminderReferralUser(userData) {
    let loggeduser=localStorage.getItem('name');

    if(userData.productName=="Personal Accident"){
      this.dynamicMailContent= "Personal Accident Insurance from SecureNow App offering  40-50% discount on market price. I recommend you to check out other products also in the SecureNow App. Signup" + "<a href='https://securenow.app/'> link </a>" + "and get 100 Wallet Points and more exciting discounts on different products."
           }
           else if(userData.productName=="Doctors Indemnity"){
            this.dynamicMailContent= "Doctors Professional Indemnity Insurance from SecureNow App is offering a 60% discount on the market price. I recommend you to check out other products also in the SecureNow App. Signup" + "<a href='https://securenow.app/'> link </a>" + "and get 100 Wallet Points and more exciting discounts on different products."
            
          }
          else if(userData.productName=="Health Insurance"){
            this.dynamicMailContent= "Health Insurance from SecureNow App offering  40-50% discount on market price. I recommend you to check out other products in the SecureNow App. Signup" + "<a href='https://securenow.app/'> link </a>" + "and get 100 Wallet Points and more exciting discounts on different products."
          }
          else if(userData.productName=="Motor Insurance"){
            this.dynamicMailContent= "Motor Insurance from SecureNow App offering  40-50% discount on market price. I recommend you to check out other products in the SecureNow App. Signup" + "<a href='https://securenow.app/'> link </a>" + "and get 100 Wallet Points and more exciting discounts on different products."
          }

          else if(userData.productName=="Term Life"){
            this.dynamicMailContent= "Term Life Insurance from SecureNow App offering  40-50% discount on market price. I recommend you to check out other products in the SecureNow App. Signup" + "<a href='https://securenow.app/'> link </a>" + "and get 100 Wallet Points and more exciting discounts on different products."
          }

          else if(userData.productName=="Hospital Cash"){
            this.dynamicMailContent= "Daily Hospital Cash Insurance from SecureNow App offering  40-50% discount on market price. I recommend you to check out other products in the SecureNow App. Signup" + "<a href='https://securenow.app/'> link </a>" + "and get 100 Wallet Points and more exciting discounts on different products."
          }

    let data1= {
     "user": [
       {
        // "bccEmail": "deepak.k@neosoftmail.com",
         "bccEmail": userData.email,
         "bccName": userData.username
       }
     ],

     
    //  "mailContent": "<b>"+loggeduser+"</b> " + " has referred you to check out a Product in the SecureNow App.Click on the " + "<a href='https://securenow.app/'> link </a>" + " for signup  and get 100 wallet Points with lots of more exciting products.",
     "mailContent": "<b>"+"Dear " + userData.name + "," + "</b> " + "<br>" + "<br>" +this.dynamicMailContent,
     "mailSubject": "Referral Reminder Mail",
     "attachments": []
   }

   console.log("daaa " + data1.mailContent);

   this.loading = true;
   this.serviceURLService.sendEmails(data1).subscribe((success: any) => {
   this.sendEmail = success.response;
   this.referral_id = success.response;
   console.log("get_reminder print==" + this.referral_id);
   this.isreferralbuttom=true;
   $('#checkReminder').modal('show');

     this.loading = false;
   },error => {
     this.loading = false;
   })
 }




//  getPamReferral() {
//   this.loading = true;
//   this.serviceURLService.getPamRefarralList(this.mobile).subscribe((success: any) => {
//     this.pamReferral = success.data;
//     // if(!success.data.length){
//     //   this.isShowReferral=false;
//     // }
//     console.log(" pam referral "+JSON.stringify(success.data[0]) );
//     console.log(" pam referral "+success.data[1]);
//     console.log(" pam referral "+success.data[1].id);
//     this.loading = false;
//   },error => {
//     this.loading = false;
//   })
// }

   
}

